module.exports = __webpack_public_path__ + "media/src/images/icon/angle-right-195692d9599a7d5440353327e7c449a5.svg";